export default "__VITE_ASSET__c1539929__"